const getForm = ({ perfiles, selectedPerfil, modalCallback, eventDataRol}) => ({
  colCount: 3,
  labelLocation: "top",
  items: [
    {
      text: "Nombre",
      dataField: "Name",
      label: {
        alignment: "left",
      },
      editorOptions: {
        placeholder: "Nombre",
        maxLength: 30,
      },
    },
    {
      text: "Perfil",
      dataField: "IdProfile",
      label: {
        alignment: "left",
      },
      editorType: "dxSelectBox",
      editorOptions: {
        placeholder: "Seleccione un perfil",
        dataSource: perfiles,
        // value: selectedPerfil,

        displayExpr: "Name",
        valueExpr: "Id",
      },
    },
    {
      itemType: "button",
      horizontalAlignment: "center",
      verticalAlignment: "bottom",
      buttonOptions: {
        text: selectedPerfil !== "" ? "Editar funcionalidades" : "Agregar funcionalidades",
        type: "default",
        onClick: modalCallback,
      },
    },
    {
      text: "Descripcion",
      dataField: "Description",
      colSpan: 3,
      label: {
        alignment: "left",
      },
      editorOptions: {
        placeholder: "Descripcion",
        maxLength: 100,
      },
    },
    {
      itemType: "empty",
      colSpan:3
    },
    {

      label: {
        visible: false
      },
      dataField: 'AdminAchsOffices',
      editorType: 'dxCheckBox',
      itemType:"boolean",
      editorOptions: {
        //value: eventDataRol && eventDataRol.data && eventDataRol.data.AdminAchsOffices ? true : false,
        text: 'Administrar oficinas ACHS',
        /*onInitialized:(e)=>{
          e.component._options.value = eventDataRol && eventDataRol.data && eventDataRol.data.AdminAchsOffices ? true : false
        }*/
      }
    }
  ],
});

export default getForm;
